import Swal from "sweetalert2";

const ToastMixin = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3500,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

export const showToast = (icon, title) => ToastMixin.fire({ icon, title });
export const showSuccess = (title) => showToast("success", title);
export const showError = (title) => showToast("error", title);
export const showWarning = (title) => showToast("warning", title);
export const showInfo = (title) => showToast("info", title);

export const showSessionExpired = () =>
  Swal.fire({
    icon: "warning",
    title: "Sesi Berakhir",
    text: "Sesi Anda telah berakhir. Silakan login kembali.",
    confirmButtonText: "Login",
    confirmButtonColor: "#FFB703",
    allowOutsideClick: false,
    allowEscapeKey: false,
  });

export const showLogoutConfirm = () =>
  Swal.fire({
    title: "Keluar dari Aplikasi?",
    text: "Anda akan keluar dari sesi ini.",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Ya, Keluar",
    cancelButtonText: "Batal",
    confirmButtonColor: "#ef4444",
    cancelButtonColor: "#6b7280",
    reverseButtons: true,
  });

export default ToastMixin;
